import config from "../../config/config.json";
import { headers } from "../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../APIHelpers/Responses";

export const userSessionServices = {
  getClientIp,
  getUserAllSession,
  forceLogoutSession,
  forceLogoutAllOtherSessions,
  terminateSingleSession,
  terminateAllOtherSessions,
};

// Get Client Ip
async function getClientIp() {
  try {
    const signal = cancelPreviousRequest("getClientIp");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getClientIp`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get User All Session
async function getUserAllSession(deviceFingerprint) {
  try {
    const signal = cancelPreviousRequest("getUserAllSession");
    let apiURL = `${config.API_URL_USER_ONBOARDING}getUserAllSession/${deviceFingerprint}`
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Force Logout Single Session
async function forceLogoutSession(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}forceLogoutSession`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Force Logout All other Sessions
async function forceLogoutAllOtherSessions(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}forceLogoutAllOtherSessions`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Terminate Single Session
async function terminateSingleSession(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}terminateSingleSession`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}

// Terminate All other Sessions
async function terminateAllOtherSessions(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}terminateAllOtherSessions`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data);
  return data;
}
